
import { ProductItem } from '@/components/product'
import i18n from '@/i18n'
import Vue from 'vue'

export default Vue.extend({
    components: { ProductItem },
    data() {
        return {
            windowWidth: window.innerWidth,
            product: {
                name: '',
                slug: '',
                brief: '',
                gallery: [],
                durations: '',
                price: '',
                destination: '',
                map: '',
                highlight: [],
                itinerary: [],
                extension: [],
                included: [],
                excluded: [],
                notice: [],
                faq: []
            },
            showModal: false,
            modalData: {
                day: '',
                description: '',
                images: []
            },
        }
    },
    async mounted() {
        window.addEventListener('resize', this.updateWindowWidth)
        await this.fetchProduct()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateWindowWidth)
    },
    methods: {
        updateWindowWidth() {
            this.windowWidth = window.innerWidth
        },
        async fetchProduct() {
            try {
                const response = await this.$axios.get(`/product`, {
                    params: {
                        fields: '*,translations.*',
                        'filter[translations][slug]': this.$route.params.slug,
                        'deep[translations][_filter][languages_code][_eq]': i18n.locale,
                        'filter[status][_eq]': 'published'
                    }
                })
                this.product = response.data.data[0].translations[0]
                this.$nextTick(() => {
                    this.$meta().refresh()
                })
            } catch (error) {
                console.error('Error fetching product data:', error)
            }
        },
        metaInfo() {
            return {
                title: `${this.product.name} | Bobu Africa`,
                link: [
                    { rel: "canonical", href: `${window.location.href}` }
                ],
                meta: [
                    { name: 'description', content: `${this.product.brief} | Bobu Africa` },
                    { property: "og:type", content: "website" },
                    { property: "og:url", content: `${window.location.href}` },
                    { property: "og:title", content: `${this.product.name} | Bobu Africa` },
                    { property: "og:description", content: `${this.product.brief} | Bobu Africa` },
                    { property: "twitter:card", content: "summary_large_image" },
                    { property: "twitter:url", content: `${window.location.href}` },
                    { property: "twitter:title", content: `${this.product.name} | Bobu Africa` },
                    { property: "twitter:description", content: `${this.product.brief} | Bobu Africa` },
                ]
            }
        },
    },
})
